module.exports = __webpack_public_path__ + "static/img/logo3.8f919928.jpg";